var TITLE_SUMMARY = " | Summary";
var TITLE_SOFTWARE = " | Software";
var TITLE_HARDWARE = " | Hardware";
var TITLE_CCLEANER = " | CCleaner";
var TITLE_DEFRAGGLER = " | Defraggler";
var TITLE_TOOLS = " | Tools";
var TITLE_OPTIONS = " | Options";
var TITLE_EVENTS = " | Events";

var TITLE_SPECIFICATIONS = "CCleaner Cloud | Specifications";
var TITLE_CLEANUP = "CCleaner Cloud | Cleanup";

var TITLE_MYCOMPUTERS = "CCleaner Cloud | My Computers";
var TITLE_ADDCOMPUTER = "CCleaner Cloud | Add Computer";

var TITLE_ACCOUNTSETTINGS = "CCleaner Cloud | Account Settings";

var OPTIONS_EVENTS_OnOff = "Computer On/Off";
var OPTIONS_EVENTS_DiskSpace = "Disk Space Warning";
var OPTIONS_EVENTS_Software = "Software Installed/Uninstalled";
var OPTIONS_EVENTS_SoftwareInstalled = "Software Installed";
var OPTIONS_EVENTS_SoftwareUninstalled = "Software Uninstalled";
var OPTIONS_EVENTS_Agent = "Agent Installation/Upgrade";
var OPTIONS_EVENTS_CCAnalysis = "CCleaner Analysis";
var OPTIONS_EVENTS_CCClean = "CCleaner Clean";
var OPTIONS_EVENTS_DFAnalysis = "Defraggler Analysis";
var OPTIONS_EVENTS_DFDefrag = "Defraggler Defrag";
var OPTIONS_EVENTS_UserLogon = "User Logins/Logoffs";
var OPTIONS_EVENTS_Printer = "Printer Events";
var OPTIONS_EVENTS_AntiVirus = "AntiVirus Events";
var OPTIONS_EVENTS_WindowsUpdatesInstalled = "Windows Updates Installed";
var OPTIONS_EVENTS_InternetOnOff = "Internet Connection On/Off";
var OPTIONS_EVENTS_NetworkAction = "Network Actions";
var OPTIONS_EVENTS_ShutdownOperations = "Shutdown Operations";
var OPTIONS_EVENTS_UserLockedUnlocked = "Computer Locked/Unlocked";
var OPTIONS_EVENTS_OnlineOffline = "Computer Online/Offline";
var OPTIONS_EVENTS_ComputerRenamed = "Computer Renamed";
var OPTIONS_EVENTS_ScheduledTasks = "Scheduled Events";

var OPTIONS_EVENTS_SECTION_ComputerAccount = "Computer and Account";
var OPTIONS_EVENTS_SECTION_InstallsUpdates= "Installs and Updates";
var OPTIONS_EVENTS_SECTION_AgomoActions = "CCleaner Cloud Actions";
var OPTIONS_EVENTS_SECTION_InfoAlerts = "Info and Alerts";